import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { CHROME_WEBSTORE_LINK } from "@/config/constants";
import useHasExtension from "@/hooks/useHasExtension";
import { ColoredCard } from "@/ui/ColoredCard";

export default function DrawerExtensionCTA() {
  const { hasExtension } = useHasExtension();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  if (hasExtension || isMobile) return null;

  return (
    <Box sx={{ px: 2, pb: 2 }}>
      <ColoredCard
        type="info"
        sx={{
          p: 2,
          borderRadius: 2,
          display: "flex",
          gap: 1,
          flexDirection: "column",
          flex: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <img
            loading="lazy"
            decoding="async"
            alt="Chrome"
            src="/chrome.svg"
            width={20}
            height={20}
          />
          <Typography variant="subtitle2">
            Enhance Browsing with Chrome Extension
          </Typography>
        </Box>
        <Button
          variant="outlined"
          color="info"
          size="small"
          href={CHROME_WEBSTORE_LINK}
          target="_blank"
        >
          Install it Free
        </Button>
      </ColoredCard>
    </Box>
  );
}
